export default __webpack_public_path__ + "static/media/AWS.721251fb.png";